module.exports = __webpack_public_path__ + "static/img/step-already.143266d5.png";